<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="small"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_label_main_material_category') || '1级物料分类'
                "
                prop="mainMaterialCategoryCode"
                ref="mainMaterialForm"
              >
                <dict-select
                  disabled
                  :placeholder="
                    $l('INDEX.pe_select_Level_1_material_classification') ||
                      '请选择1级物料分类'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.mainMaterialCategoryCode"
                  :body="mainMaterialParams"
                  :selectedLabel.sync="formData.mainMaterialCategoryName"
                  url="/master/material/category/select"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_label_detail_material_category') ||
                    '2级物料分类'
                "
                prop="detailMaterialCategoryCode"
                ref="detailMaterialForm"
              >
                <dict-select
                  :placeholder="
                    $l('INDEX.pe_select_Level_2_material_classification') ||
                      '请选择2级物料分类'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.detailMaterialCategoryCode"
                  :body="detailMaterialParams"
                  :selectedLabel.sync="formData.fabricPosition"
                  url="/master/material/category/select"
                  @change="reset()"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div style="height: 64px;" class="d-flex align-items-end">
                <b-button
                  :disabled="
                    !formData.mainMaterialCategoryCode ||
                      !formData.detailMaterialCategoryCode
                  "
                  size="sm"
                  variant="outline-success"
                  @click="addMaterial()"
                >
                  {{ '新增面料' }}
                </b-button>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="d-flex">
        <div class="side-frame"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ '面料基础信息' }}
          </span>
        </div>
      </div>
      <div class="mt-2 d-flex">
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ formData.fabricNo ? formData.fabricNo : '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ formData.fabricName ? formData.fabricName : '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ formData.materialNameEn ? formData.materialNameEn : '--' }}
          </span>
        </div>
      </div>
      <div>
        <span style="font-size: 14px; color: #606266">
          {{ formData.fabricDisplayName ? formData.fabricDisplayName : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ formData.displayNameEn ? formData.displayNameEn : '--' }}
        </span>
      </div>

      <div class="d-flex">
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ formData.metadataDesc ? formData.metadataDesc : '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ formData.metadataDescEn ? formData.metadataDescEn : '--' }}
          </span>
        </div>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button
          @click="() => this.$emit('save')"
          type="primary"
          size="small"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>

    <choose-fabric-dialog
      :title="$l('INDEX.dialog_title_fabric_information') || '添加面料信息'"
      :visible.sync="fabricDialogVisible"
      type="radio"
      @confirm="onFabricConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    form: { type: Object, default: () => {} },
  },

  data() {
    return {
      fabricDialogVisible: false,
      backDialogVisible: false,
      fabricPropertiesVisible: true,
      mainMaterialParams: { parentCode: 'ABSHome' },
      detailMaterialParams: {
        parentCode: 'e059ade0-d9cc-45b3-8e92-cc64ecb3d206',
      },
      size: 'small',
      formData: {
        materialCode: '',
        fabricNo: '',
        fabricName: '',
        materialNameEn: '',
        fabricDisplayName: '',
        displayNameEn: '',
        scmCode: '',
        mainMaterialCategoryCode: 'e059ade0-d9cc-45b3-8e92-cc64ecb3d206',
        detailMaterialCategoryCode: '',
        mainMaterialCategoryName: '面料',
        fabricPosition: '',
        scmName: '',
        defaultImageCode: '',
        fabricWidth: 0,
        fabricWeight: 0,
      },
      scmParams: {},
      qtyUnitParams: { dictType: 'widUnit' },
      rules: {
        mainMaterialCategory: [
          {
            required: true,
            message:
              this.$l('INDEX.pe_select_Level_1_material_classification') ||
              '请选择1级物料分类',
            trigger: 'change',
          },
        ],
        detailMaterialCategoryCode: [
          {
            required: true,
            message:
              this.$l('INDEX.pe_select_Level_2_material_classification') ||
              '请选择2级物料分类',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    form: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      this.reset()
      if (this.form._XID) {
        this.formData = this.form
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const { fabricNo } = this.formData
      if (!fabricNo) {
        this.$message.error(
          this.$l('tips_pleaseChooseFabric') || '请选择面料！'
        )
        return
      }
      return this.formData
    },
    addMaterial() {
      const {
        detailMaterialCategoryCode,
        mainMaterialCategoryCode,
      } = this.formData
      if (!mainMaterialCategoryCode || !detailMaterialCategoryCode) return

      this.fabricDialogVisible = true
    },
    onFabricConfirm(data) {
      let metadataDesc =
        data.wid +
        ' ' +
        data.widUnit +
        '-' +
        data.fabricWeight +
        ' ' +
        data.fabricWeightUnit
      let metadataDescEn =
        data.wid +
        ' ' +
        data.widUnit +
        '-' +
        data.fabricWeight +
        ' ' +
        data.fabricWeightUnit
      this.formData.metadataDesc = metadataDesc
      this.formData.metadataDescEn = metadataDescEn
      this.formData.fabricCode = data.fabricCode
      this.formData.fabricNo = data.fabricNo
      this.formData.fabricName = data.fabricName
      this.formData.materialNameEn = data.fabricNameEn
      this.formData.fabricDisplayName = data.fabricContent
      this.formData.displayNameEn = data.fabricContentEn
      this.formData.scmCode = data.supCode
      this.formData.scmName = data.supName
      this.formData.defaultImageCode = data.defaultImageCode
      this.formData.fabricWidth = data.wid
      this.formData.fabricWeight = data.fabricWeight
    },
    reset() {
      this.formData.fabricNo = ''
      this.formData.fabricName = ''
      this.formData.materialNameEn = ''
      this.formData.fabricDisplayName = ''
      this.formData.displayNameEn = ''
      this.formData.metadataDesc = ''
      this.formData.metadataDescEn = ''
      this.formData.scmCode = ''
      this.formData.mainMaterialCategoryName = '面料'
      this.formData.fabricPosition = ''
      this.formData.scmName = ''
      this.formData.defaultImageCode = ''
      this.formData.fabricWidth = 0
      this.formData.fabricWeight = 0
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
